import { FormDataSettingsService } from '@/modules/global-settings/onboarder/services/form-data-settings.service';
import { make } from 'vuex-pathify';
// Create a new instance of the service
const formDataSettingsService = new FormDataSettingsService();
// Creatre state for the module
export const state = {
  formData: {}
};
// Create mutations
export const mutations = {
  ...make.mutations(state)
};
// Create actions
export const actions = {
  /**
   * Fetch form data
   * @async
   * @param {Object} context - Vuex context
   * @returns {number | undefined} - HTTP status code
   * @private This will set the formData state
   */
  async fetchFormData({ commit, dispatch }) {
    const { status, data } = await formDataSettingsService.fetchFormData();
    if (status == 200) {
      if (!data || data.length === 0) {
        const { data } = await dispatch('createFormData');
        commit('SET_FORM_DATA', data[0]);
        return;
      }
      commit('SET_FORM_DATA', data[0]);
    }
    return status;
  },

  /**
   * Update form data
   * @async
   * @param {Object} context - Vuex context
   * @param {Object} payload - Form data ID and updates
   * @param {string} payload.id - Form data ID
   * @param {Object} payload.updates - Form data updates
   * @returns {number | undefined} - HTTP status code
   * @private This will refetch the formData state
   */
  async updateFormData({ dispatch }, { id, updatedFormData }) {
    const { status } = await formDataSettingsService.updateFormData(
      id,
      updatedFormData
    );
    if (status == 200) {
      await dispatch('fetchFormData');
    }
    return status;
  },

  /**
   * Create form data
   * @async
   * @param {Object} context - Vuex context
   * @returns {Object} - HTTP status code and data
   * @private This will refetch the formData state
   */
  async createFormData({ dispatch }) {
    const { status, data } = await formDataSettingsService.createFormData();
    if (status == 201) {
      await dispatch('fetchFormData');
    }
    return { status, data };
  }
};
// Create getters
export const getters = {};
